import React from "react"
import { Button, FormControl, FormGroup } from "react-bootstrap"
import { blockingFetchService } from "../../lib/blockingFetch"
import { validateAmountState, validateCommissions, VALIDATION_TYPE } from "../../lib/utils"
import FontAwesome from "react-fontawesome"
import apiServerApi from "../../redux/sagas/apiServerApi"
import BundleDetailForm from "../Bundles/BundleDetailForm"
import AlertModal from "../fragments/AlertModal"
import CommissionItem from "../fragments/CommissionItem"

export default class DisplayBundleModal extends React.Component {

  constructor(props) {

    super(props)

    const { bundle } = this.props,
    purchaseCost = (bundle && bundle.purchaseCost) ? bundle.purchaseCost : '',
    commissions = (bundle && bundle.commissions) ? bundle.commissions.filter(item => !!item) : []

    this.state = {

      purchaseCost,
      shouldRenderPurchaseCostForm: false,
      purchaseCostValidationState: VALIDATION_TYPE.NULL,
      running: false,
      error: null,

      commissions,
      shouldRenderCommissionsForm: false,
      commissionsValidationState: VALIDATION_TYPE.NULL,
      runningCommissions: false,
      errorCommissions: null,
    }
  }

  purchaseCostChanged = purchaseCost => this.setState({
    purchaseCost,
    purchaseCostValidationState: validateAmountState(purchaseCost, false),
    error: null,
  })

  commissionChanged = (id, index) => {

    const { commissions } = this.state,
    current = commissions[index]
    current.id = id
    commissions[index] = current

    this.setState({
      commissions,
      commissionsValidationState: validateCommissions(commissions, false),
      errorCommissions: null,
    })
  }

  addNewCommission = () => {
    const { commissions } = this.state
    commissions.push({ id: '' })
    this.setState({
      commissions,
      commissionsValidationState: validateCommissions(commissions, true),
      errorCommissions: null,
    })
  }

  removeCommission = index => {
    const { commissions } = this.state
    commissions.splice(index, 1)
    this.setState({
      commissions,
      commissionsValidationState: validateCommissions(commissions, false),
      errorCommissions: null,
    })
  }

  savePurchaseCost = () => {

    const { purchaseCost } = this.state,
    amountState = validateAmountState(purchaseCost, false)
    this.setState({ purchaseCostValidationState: amountState })

    if (amountState !== VALIDATION_TYPE.SUCCESS) {
      console.log('Purchase cost not valid!')
      return
    }

    this.setState({
      running: true,
      error: null,
    })

    const { loanId, setLoan } = this.props
    blockingFetchService(
      accessToken => apiServerApi.updateLoanBundlepurchasecost(accessToken, loanId, purchaseCost),
      data => {
        this.setState({ shouldRenderPurchaseCostForm: false })
        setLoan(loanId, data)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  saveCommissions = () => {

    const { commissions } = this.state,
    commissionsState = validateCommissions(commissions, false)
    this.setState({ commissionsValidationState: commissionsState })

    if (commissionsState !== VALIDATION_TYPE.SUCCESS) {
      console.log('Commissions not valid!')
      return
    }

    this.setState({
      runningCommissions: true,
      errorCommissions: null,
    })

    const { loanId, setLoan } = this.props
    blockingFetchService(
      accessToken => apiServerApi.updateLoanBundleCommissions(accessToken, loanId, commissions),
      data => {
        this.setState({ shouldRenderCommissionsForm: false })
        setLoan(loanId, data)
      },
      error => this.setState({ errorCommissions: error.text }),
      _ => this.setState({ runningCommissions: false })
    )
  }

  onUpdatePurchaseCost = () => this.setState({ shouldRenderPurchaseCostForm: true })

  onUpdateCommissions = () => this.setState({ shouldRenderCommissionsForm: true })

  cancelUpdatePurchaseCost = () => this.setState({ shouldRenderPurchaseCostForm: false })

  cancelUpdateCommissionsForm = () => this.setState({ shouldRenderCommissionsForm: false })

  renderUpdatePurchaseCostForm = () => {

    const { purchaseCost, running, purchaseCostValidationState, error } = this.state

    return (
      <div className="flex-row-simple">

        <FormGroup controlId='purchaseCost' validationState={ purchaseCostValidationState }>
          <FormControl type="text" placeholder='Purchase cost'
            value={ purchaseCost } disabled={ running }
            onChange={e => this.purchaseCostChanged(e.target.value)}
          />
          { !!error && <small className="red">{ error }</small> }
        </FormGroup>

        <div className="ml-20">
          <Button bsStyle="primary" onClick={ this.savePurchaseCost } disabled={ running }
            bsSize='small' title="Save">
            Save
          </Button>

          <Button bsStyle='link' onClick={ this.cancelUpdatePurchaseCost } disabled={ running } 
            className='ml-3 cursor-pointer blue' bsSize='small' title="Cancel">
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  renderLoanCommissionsForm = () => {

    const { loanCommissions } = this.props,
    { commissions, commissionsValidationState, runningCommissions, errorCommissions } = this.state

    return (
      <div>
        <FormGroup controlId='loanCommissions' validationState={ commissionsValidationState }>

          { commissions.map((item, index) => 
            <CommissionItem
              key={ `table${index}` }
              item={ item } 
              index={ index }
              loanCommissions={ loanCommissions}
              onChange={ this.commissionChanged } 
              onRemove={ this.removeCommission } 
            />
          )}

          <Button onClick={ this.addNewCommission } bsStyle="link" bsSize='small'
            disabled={ runningCommissions } title='Add new item'>
            <FontAwesome name="plus" /> Add
          </Button>

          { !!errorCommissions && <small className="red">{ errorCommissions }</small> }
        </FormGroup>

        <div className="text-center">
          <Button bsStyle='link' onClick={ this.cancelUpdateCommissionsForm } disabled={ runningCommissions } 
            bsSize='small' title="Cancel">
            Cancel
          </Button>

          <Button bsStyle="primary" onClick={ this.saveCommissions } disabled={ runningCommissions }
            bsSize='small' title="Save">
            Save
          </Button>
        </div>
      </div>
    )
  }

  render() {

    const { bundle, show, close } = this.props,

    { shouldRenderPurchaseCostForm, shouldRenderCommissionsForm } = this.state,

    body = !!bundle && <BundleDetailForm 
      bundle={ bundle }
      onUpdatePurchaseCost={ this.onUpdatePurchaseCost }
      onUpdateCommissions={ this.onUpdateCommissions }
      renderUpdatePurchaseCostForm={ shouldRenderPurchaseCostForm && this.renderUpdatePurchaseCostForm() }
      renderUpdateCommissionsForm={ shouldRenderCommissionsForm && this.renderLoanCommissionsForm() }
    />

    return <AlertModal bsSize='lg' show={ show } close={ close } title="Preview" body={ body } />
  }
}



// WEBPACK FOOTER //
// ./src/components/Loans/DisplayBundleModal.js